import { API } from "./utils"

export const societies = {
  societiesList: () => API.get("/societies/"),
} 